import 'babel-polyfill';

import React from 'react'
import ReactDOM from 'react-dom'
import Immutable from 'immutable'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension'
import { IntlProvider, addLocaleData } from 'react-intl'


import history from './history'
//import registerServiceWorker from './registerServiceWorker'
import reducer from './reducers'
import sagas from './sagas'
import App from 'containers/App'

import 'resources/_antd.less' // redefinition AntDesign variables
import 'bootstrap/dist/css/bootstrap.min.css' // bootstrap styles
import 'resources/AntStyles/AntDesign/antd.cleanui.scss'
import 'resources/CleanStyles/Core/core.cleanui.scss'
import 'resources/CleanStyles/Vendors/vendors.cleanui.scss'
import 'resources/dashboard.scss'
import 'chartist-plugin-tooltips'

import en from 'react-intl/locale-data/en'
import de from 'react-intl/locale-data/de'

addLocaleData([...en, ...de])

const router = routerMiddleware(history)
const sagaMiddleware = createSagaMiddleware()
const middlewares = [router, sagaMiddleware]
const store = createStore(reducer, Immutable.Map({}), composeWithDevTools(applyMiddleware(...middlewares)))

sagaMiddleware.run(sagas)


ReactDOM.render(
	<Provider store={store}>
        <IntlProvider locale="de">
	       	<ConnectedRouter history={history}>
			     <App />
		    </ConnectedRouter>
        </IntlProvider>
	</Provider>, 
	document.getElementById('root')
)
//registerServiceWorker()


export default history



// WEBPACK FOOTER //
// ./src/index.js